import { useParams, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'
import { useContentById } from '../../hooks/useContent'
import { ArticleDetailPage } from '../article-detail/ArticleDetail.page'
import { AudioDetailPage } from '../audio-detail/AudioDetail.page'
import { VideoDetailPage } from '../video-detail/VideoDetail.page'

export const ContentPreviewPage = () => {
  const { id } = useParams()

  const [searchParameters] = useSearchParams()
  const draft = searchParameters.get('draft') === 'true'

  const { data, error, isLoading } = useContentById(id, draft)
  if (isLoading) {
    return (
      <Container>
        <AnimatedLoader />
      </Container>
    )
  }

  if (error) {
    return (
      <ErrorContainer>
        <H2>Fout bij het laden van de inhoud</H2>
      </ErrorContainer>
    )
  }

  switch (data?.type) {
    case 'article': {
      return <ArticleDetailPage preview draft={draft} />
    }
    case 'video': {
      return <VideoDetailPage preview draft={draft} />
    }
    case 'audio': {
      return <AudioDetailPage preview draft={draft} />
    }
    default: {
      return (
        <Container>
          <H2>Niet ondersteund inhoudstype</H2>
        </Container>
      )
    }
  }
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  max-width: 800px;
`
